import React, { useState, useEffect } from 'react'
import { Drawer, Card, Button, Form, Row, Col, Input, notification, Checkbox } from 'antd'
import {
  formItemLayout,
  InputBox,
  chooseEmailModalFxn
} from '../../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import { SendAbstractReceiveDate } from '../actions'
import moment from 'moment'

const SelectReceiveDateDrawer = (props) => {
  let { visible, onClose, abstract, reviewerId, form: { getFieldDecorator, getFieldValue, setFieldsValue } } = props
  let [articleAttachment, setArticleAttachment] = useState({})
  let [commentsAttachment, setCommentsAttachment] = useState({})
  let [checked, setChecked] = useState(false)
  let [articleSeeAgain, setArticleSeeAgain] = useState(false)
  let [commentsAttachment2, setCommentsAttachment2] = useState({})
  let [articleAttachment2, setArticleAttachment2] = useState({})
  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      setFieldsValue({ receiveDate: moment() })
    }, 500)
  }, [])

  const inputSchema = {
    fields: [
      {
        label: 'Receive Date',
        key: 'receiveDate',
        type: 'date',
        span: 12,
        required: true,
        placeholder: 'Receive Date'
      },
      // Inside inputSchema.fields:
      {
        label: 'Abstract Comments attachment',
        span: 12,
        customField: (
          <InputBox title={`Abstract Comments attachment*`}>
            <Input
              type={'file'}
              name={'abstractcommentsAttachment'} // Must match backend name exactly
              className={'form-control'}
              onChange={(e) => chooseDocument(e)}
            />
          </InputBox>
        )
      },
      {
        label: 'Abstract attachment',
        span: 12,
        customField: (
          <InputBox title={`Abstract attachment*`}>
            <Input
              type={'file'}
              name={'abstractAttachment'} // Must match backend name exactly
              className={'form-control'}
              onChange={(e) => chooseDocument(e)}
            />
          </InputBox>
        )
      },
      {
        label: 'Second Abstract Comments Attachment',
        span: 12,
        customField: (
          <InputBox title={`Second Abstract Comments Attachment`}>
            <Input
              type={'file'}
              name={'secondAbstractCommentsAttachment'} // Updated Name
              className={'form-control'}
              onChange={(e) => chooseDocument2(e)}
            />
          </InputBox>
        )
      },
      {
        label: 'Second Abstract Attachment',
        span: 12,
        customField: (
          <InputBox title={`Second Abstract Attachment`}>
            <Input
              type={'file'}
              name={'secondAbstractAttachment'} // Updated Name
              className={'form-control'}
              onChange={(e) => chooseDocument2(e)}
            />
          </InputBox>
        )
      },
      {
        type: 'checkBox',
        span: 18,
        customField: (
          <Checkbox onChange={(e) => setChecked(!checked)}>
            Early Comments (Apart from this your early response is highly appreciated)
          </Checkbox>
        )
      },
      {
        type: 'checkBox',
        span: 18,
        customField: (
          <Checkbox style={{ marginTop: 10 }} onChange={(e) => setArticleSeeAgain(!articleSeeAgain)}>
            Reviewer wants to see the Abstract again.
          </Checkbox>
        )
      }
    ]
  }

  const chooseDocument = (e) => {
    let { name, files } = e.target;
    if (files && files.length) {
      if (name === 'abstractcommentsAttachment') {
        setCommentsAttachment(files[0]);
      }
      if (name === 'abstractAttachment') {
        setArticleAttachment(files[0]);
      }
    }
  };
  const chooseDocument2 = (e) => {
    let { name, files } = e.target;
    if (files && files.length) {
      if (name === 'secondAbstractCommentsAttachment') {
        setCommentsAttachment2(files[0]);
      }
      if (name === 'secondAbstractAttachment') {
        setArticleAttachment2(files[0]);
      }
    }
  };
  // const handleSubmit = e => {
  //   const { form } = props
  //   e.preventDefault()
  //   form.validateFieldsAndScroll(async (err, valData) => {
  //     if (!err) {
  //       if (!articleAttachment.name || !commentsAttachment.name) {
  //         notification.error({ message: 'Choose both Attachments' })
  //         return
  //       }
  //
  //       let fd = new FormData()
  //       let targetReviewer = abstract.selectedReviewer.find(r =>
  //         (r.reviewerId._id || r.reviewerId) === reviewerId
  //       );
  //       let revName = (targetReviewer && targetReviewer.reviewerId && targetReviewer.reviewerId.name)
  //         ? targetReviewer.reviewerId.name
  //         : 'Unknown';
  //       let obj = {
  //         ...valData,
  //         abstractId: abstract._id,
  //         earlyComments: checked,
  //         abstractSeeAgain: articleSeeAgain,
  //         reviewerId,
  //         reviewerName: revName
  //       }
  //
  //       chooseEmailModalFxn({
  //         callback: async (email) => {
  //           obj.fromEmail = email
  //           fd.append('obj', JSON.stringify(obj))
  //           fd.append('abstractAttachment', articleAttachment);
  //           fd.append('abstractcommentsAttachment', commentsAttachment);
  //           let { success } = await dispatch(SendAbstractReceiveDate(fd))
  //           // if (success) {
  //           //   dispatch({ type: 'START_LOAD_ABSTRACT' })
  //           //   onClose()
  //           //   setTimeout(() => {
  //           //     window.location.reload();
  //           //   }, 500);
  //           // }'
  //           if (success) {
  //             dispatch({ type: 'START_LOAD_ABSTRACT' })
  //             onClose()
  //           }
  //         }
  //       })
  //     }
  //   })
  // }

  const handleSubmit = e => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        // Validation: Ensure mandatory first attachments exist
        if (!articleAttachment.name || !commentsAttachment.name) {
          notification.error({ message: 'Choose both mandatory Attachments' })
          return
        }

        let fd = new FormData()
        let targetReviewer = abstract.selectedReviewer.find(r =>
          (r.reviewerId._id || r.reviewerId) === reviewerId
        );
        let revName = (targetReviewer && targetReviewer.reviewerId && targetReviewer.reviewerId.name)
          ? targetReviewer.reviewerId.name
          : 'Unknown';

        let obj = {
          ...valData,
          abstractId: abstract._id,
          earlyComments: checked,
          abstractSeeAgain: articleSeeAgain,
          reviewerId,
          reviewerName: revName
        }

        chooseEmailModalFxn({
          callback: async (email) => {
            obj.fromEmail = email
            fd.append('obj', JSON.stringify(obj))

            // 1. Append Mandatory Files
            fd.append('abstractAttachment', articleAttachment);
            fd.append('abstractcommentsAttachment', commentsAttachment);

            // 2. Append Optional Second Files (If they exist)
            if (commentsAttachment2 && commentsAttachment2.name) {
              fd.append('secondAbstractCommentsAttachment', commentsAttachment2);
            }
            if (articleAttachment2 && articleAttachment2.name) {
              fd.append('secondAbstractAttachment', articleAttachment2);
            }
            // 3. Dispatch
            let { success } = await dispatch(SendAbstractReceiveDate(fd))
            if (success) {
              dispatch({ type: 'START_LOAD_ABSTRACT' })
              onClose()
            }
          }
        })
      }
    })
  }
  return (
    <Drawer
      title={'Select Receive Date'}
      width={'55%'}
      visible={visible}
      placement="right"
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16} className={'wrapRow'}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span ? item.span : 8} key={key}>
                {item.customField ? item.customField :
                  <GetEachFormFields getFieldDecorator={getFieldDecorator}
                                     item={item}
                                     formItemLayout={formItemLayout} />}
              </Col>
            ))}
            <Col style={{ marginTop: 50 }} span={24}>
              <Form.Item>
                <Button type='primary' htmlType='submit'>Submit</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

const WrappedForm = Form.create()(SelectReceiveDateDrawer)
export default WrappedForm
